import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslationsProviderService } from '../../../../services/translations-provider/translations-provider.service';
import { QueryBuilderConfig } from '../../sem-query-builder/query-builder.interfaces';
import { UserService } from '../../../../services/user/user-provider.service';
import { UserSearchSettingModel } from '../../../../models/search/user-search-setting-model';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../../../services/utility/utility.service';
import { DynamicLoadingUtil } from '../../../../shared/helpers/dynamic-loading-util';
import { SearchService } from '../../../../services/search/search.service';
import { parse } from 'path';
import { filter } from 'lodash';
import { LocalStorageService } from '../../../../services/local-storage-service/local-storage.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { error } from 'console';
import { RouteNavigationService } from '../../../../services/dynamic-routes-loader/route-navigation.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-sem-view-settings-dialog',
  templateUrl: './sem-view-settings-dialog.component.html',
  styleUrls: ['./sem-view-settings-dialog.component.css']
})
export class SemViewSettingsDialogComponent implements OnInit {
  
  // other dialog settings
  createNewView: boolean;
  validationErrorMessage: string = "";
  onlyGridSettings: boolean = false;
  params: any;

  // properties for tab iskalna polja
  availibleSearchFields: any[] = [];
  addedSearchFields: any[] = [];
  originalSearchFieldsList: any[] = [];
  originalAddedSearchFieldsList: any[] = [];
  selectedSearchItem: any;

  // properties for tab prikazna polja
  availibleDisplayFields: any[] = [];
  addedDisplayFields: any[] = [];
  originalDisplayFieldsList: any[] = [];
  originalAddeddisplayFieldsList: any[] = [];
  selectedDisplayItem: any;

  // properties for basic view settings
  viewLabel: string = "";
  placeHolderTitle: string = "";
  currentSettingId: number = 0;
  modelName: string = "";  

  // properties for query builder
  queryBuilderModel: any;
  queryBConfig: any;

  // properties for left menu nodes tab
  leftMenuNodes: {Title: string, Id: number}[] = [];
  leftMenuNode: any;
  
  canEditBasicAndFilter:boolean = true;
  userIsAdmin: boolean = false;
  globalView: boolean = false;
  addOnLeftMenuRoot: boolean = false;
  leftMenuNodeOrder: number;
  currentLeftNavNodeId: number;


  // properties for sort tab
  selectedSortFields: any[] = [];
  availibleSortFields: any[] = [];

  constructor(public dialogRef: MatDialogRef<SemViewSettingsDialogComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public translationsService: TranslationsProviderService, public userService: UserService, private router: Router,
    private utilityService: UtilityService, private searchService: SearchService, private localStorageService: LocalStorageService, public route: ActivatedRoute,
    private routeNavigationService: RouteNavigationService) {
  }  

  ngOnInit() {

    this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.params = params;
      });
      
    this.loadLeftMenuNodeOptions();

    if(this.dialogData){

      let userStringJson = this.localStorageService.get("user");
      if(userStringJson){
        try{
          let user = JSON.parse(userStringJson);
          if(user && typeof user["IsAdmin"] != "undefined" && user["IsAdmin"] !== null){
            this.userIsAdmin = user["IsAdmin"];
          } 
        }catch{}        
      }      

      if(this.dialogData["onlyGridSettings"]){
        this.onlyGridSettings = this.dialogData["onlyGridSettings"];
      }
      
      this.createNewView = this.dialogData["createNewView"];
      this.canEditBasicAndFilter = this.dialogData["canEditBasicAndFilter"];
      // basic view info
      // based on current setting ID, we will create copy of some of the fields user cannot set via UI
      this.currentSettingId = this.dialogData["currentSettingId"];
      this.viewLabel = this.dialogData["viewLabel"];
      this.placeHolderTitle = this.dialogData["searchPlaceholderTitle"];
      this.globalView = this.dialogData["globalView"];
      this.modelName = this.dialogData["modelName"];

      // search fields tab
      if(this.dialogData["availibleSearchFields"]){
        this.availibleSearchFields = this.dialogData["availibleSearchFields"].map(x => Object.assign({}, x));
      }
      
      if(this.dialogData["originalSearchFieldsList"]){
        this.originalSearchFieldsList = this.dialogData["originalSearchFieldsList"].map(x => Object.assign({}, x));
      }
      
      if(this.dialogData["addedSearchFields"]){
        this.addedSearchFields = this.dialogData["addedSearchFields"].map(x => Object.assign({}, x));
      }
      
      if(this.dialogData["originalAddedSearchFieldsList"]){
        this.originalAddedSearchFieldsList = this.dialogData["originalAddedSearchFieldsList"].map(x => Object.assign({}, x));
      }
      

      // display fields tab
      if(this.dialogData["availibleDisplayFields"]){
        this.availibleDisplayFields = this.dialogData["availibleDisplayFields"].map(x => Object.assign({}, x));
      }
      
      if(this.dialogData["originalDisplayFieldsList"]){
        this.originalDisplayFieldsList = this.dialogData["originalDisplayFieldsList"].map(x => Object.assign({}, x));
      }
      
      if(this.dialogData["addedDisplayFields"]){
        this.addedDisplayFields = this.dialogData["addedDisplayFields"].map(x => Object.assign({}, x));
      }
      
      if(this.dialogData["originalAddedDisplayFieldsList"]){
        this.originalAddeddisplayFieldsList = this.dialogData["originalAddedDisplayFieldsList"].map(x => Object.assign({}, x));
      }
      

      // filter tab
      this.queryBuilderModel = this.dialogData["queryBuilderModel"];
      this.queryBConfig = this.dialogData["queryBuilderConfig"];

      //sorting tab
      this.availibleSortFields = this.dialogData["sortableFields"];
      this.selectedSortFields = this.dialogData["selectedSortFields"];

      // left menu navigationnode tab
      this.addOnLeftMenuRoot = this.dialogData["addOnLeftMenuRoot"];
      this.leftMenuNodeOrder = this.dialogData["navNodeOrder"];
      this.currentLeftNavNodeId = this.dialogData["currentLeftNavNodeId"];
      if(this.leftMenuNodes){
        this.leftMenuNode = this.leftMenuNodes.find(x => x.Id == this.dialogData["navNodeParentId"]);
      }      
    }
  }

  searchFieldSearch(searchValue: string) {
    if (typeof searchValue != "undefined" && searchValue.trim() != "") {
      this.availibleSearchFields = this.originalSearchFieldsList.map(x => Object.assign({}, x));
      let lowerCaseSearchValue = searchValue.toLocaleLowerCase();
      let filteredItems = this.availibleSearchFields.filter(x => x.Translation.toLocaleLowerCase().includes(lowerCaseSearchValue));
      this.availibleSearchFields = filteredItems;
    }else{
      this.availibleSearchFields = this.originalSearchFieldsList.map(x => Object.assign({}, x));
    }
  }

  displayFieldSearch(searchValue: string) {
    if (typeof searchValue != "undefined" && searchValue.trim() != "") {
      this.availibleDisplayFields = this.originalDisplayFieldsList.map(x => Object.assign({}, x));
      let lowerCaseSearchValue = searchValue.toLocaleLowerCase();
      let filteredItems = this.availibleDisplayFields.filter(x => x.Translation.toLocaleLowerCase().includes(lowerCaseSearchValue));
      this.availibleDisplayFields = filteredItems;
    }else{
      this.availibleDisplayFields = this.originalDisplayFieldsList.map(x => Object.assign({}, x));
    }
  }

  searchListItemClick(event, newValue) {
    this.selectedSearchItem = newValue;
  }
  displayListItemClick(event, newValue) {
    this.selectedDisplayItem = newValue;
  }

  onCheckboxChange(event: any): void {
    if(this.addOnLeftMenuRoot === true){
      this.leftMenuNode = null;
    }
  }

  closeDialog(){    
    this.dialogRef.close(null);
  }

  deleteView(){
    if(this.currentSettingId && this.currentSettingId > 0){
      
      this.userService.deleteSearchView(this.currentSettingId).subscribe({
        next: response => {
                              
          if(response.error === true){
            this.showCustomErrorMessage("Napaka: " + response.message);              
          }else{
            // we get UserSearchSetting.View.Id back, we only need this to redirect to new view
            let currentUrl = this.router.url;
            // data represent id of UserSearchSetting.View (this is what we need to redirect to new view, everything else in url is the same)
            if(response.data && response.data > 0){
              // redirect to new view
              // replace view url param with new viewid            
              const newViewUrl = this.utilityService.updateURLQueryParam(currentUrl, 'view', response.data.toString());
              this.utilityService.processNavigationUrl(newViewUrl, null, true, true);
              this.dialogRef.close();
            }else{
              // if no default view, redirect to dashboard
              //this.utilityService.processNavigationUrl(newViewUrl, null, true, true);
              this.dialogRef.close();
            }  
          }

          DynamicLoadingUtil.loader.showLoader = false;         
        },
        error: error => { 
          this.showCustomErrorMessage("Napaka");       
          DynamicLoadingUtil.loader.showLoader = false;
        }
      });
    }
  }

  addSearchField() {
    if (typeof this.selectedSearchItem != "undefined" && this.selectedSearchItem != null) {
      // remove from array of availibleFields
      let index = this.availibleSearchFields.findIndex(x => x.Name == this.selectedSearchItem.Name);
      if (index >= 0) {
        //this.originalFieldsList = this.availibleFields.map(x => Object.assign({}, x));
        this.availibleSearchFields.splice(index, 1);
        // add to array of added fields
        this.addedSearchFields.push(this.selectedSearchItem);

        if (this.originalSearchFieldsList != null && typeof this.originalSearchFieldsList != "undefined") {
          // find selected in original and remove
          let i = this.originalSearchFieldsList.findIndex(x => x.Name == this.selectedSearchItem.Name);
          if (i >= 0) {
            this.originalSearchFieldsList.splice(i, 1);
          }
        }

        
        // selectedGridField is next availible grid field
        let newSelectedItem = this.availibleSearchFields[index - 1];
        if(newSelectedItem < 0){
          newSelectedItem = 0;
        }

        if(newSelectedItem != null && typeof newSelectedItem != "undefined"){
          this.selectedSearchItem = newSelectedItem;
        }else{
          // get first if at least one field is present
          if(this.availibleSearchFields.length > 0){          
            this.selectedSearchItem = this.availibleSearchFields[0];
          }else{
            this.selectedSearchItem = null;
          }                
        }   
      }
    }
  }

  addDisplayField() {
    if (typeof this.selectedDisplayItem != "undefined" && this.selectedDisplayItem != null) {
      // remove from array of availibleFields
      let index = this.availibleDisplayFields.findIndex(x => x.Name == this.selectedDisplayItem.Name);
      if (index >= 0) {
        //this.originalFieldsList = this.availibleFields.map(x => Object.assign({}, x));
        this.availibleDisplayFields.splice(index, 1);
        // add to array of added fields
        this.addedDisplayFields.push(this.selectedDisplayItem);

        if (this.originalDisplayFieldsList != null && typeof this.originalDisplayFieldsList != "undefined") {
          // find selected in original and remove
          let i = this.originalDisplayFieldsList.findIndex(x => x.Name == this.selectedDisplayItem.Name);
          if (i >= 0) {
            this.originalDisplayFieldsList.splice(i, 1);
          }
        }

        
        // selectedGridField is next availible grid field
        let newSelectedItem = this.availibleDisplayFields[index - 1];
        if(newSelectedItem < 0){
          newSelectedItem = 0;
        }

        if(newSelectedItem != null && typeof newSelectedItem != "undefined"){
          this.selectedDisplayItem = newSelectedItem;
        }else{
          // get first if at least one field is present
          if(this.availibleDisplayFields.length > 0){          
            this.selectedDisplayItem = this.availibleDisplayFields[0];
          }else{
            this.selectedDisplayItem = null;
          }                
        }   
      }
    }
  }

  removeAddedSearchField() {
    if (typeof this.selectedSearchItem != "undefined" && this.selectedSearchItem != null) {
      // remove from array of addedFields
      let index = this.addedSearchFields.findIndex(x => x.Name == this.selectedSearchItem.Name);
      if (index >= 0) {
        this.addedSearchFields.splice(index, 1);
        // add to array of availibleFields
        this.availibleSearchFields.unshift(this.selectedSearchItem);
        this.originalSearchFieldsList.unshift(this.selectedSearchItem);
        this.selectedSearchItem = null;
      }


       // selectedGridField is next availible grid field
       let newSelectedItem = this.addedSearchFields[index - 1];
       if(newSelectedItem < 0){
         newSelectedItem = 0;
       }
 
       if(newSelectedItem != null && typeof newSelectedItem != "undefined"){
         this.selectedSearchItem = newSelectedItem;
       }else{
         // get first if at least one field is present
         if(this.addedSearchFields.length > 0){          
           this.selectedSearchItem = this.addedSearchFields[0];
         }else{
           this.selectedSearchItem = null;
         }                
       }  
    }
  }

  removeAddedDisplayField(){
    if (typeof this.selectedDisplayItem != "undefined" && this.selectedDisplayItem != null) {
      // remove from array of addedFields
      let index = this.addedDisplayFields.findIndex(x => x.Name == this.selectedDisplayItem.Name);
      if (index >= 0) {
        this.addedDisplayFields.splice(index, 1);
        // add to array of availibleFields
        this.availibleDisplayFields.unshift(this.selectedDisplayItem);
        this.originalDisplayFieldsList.unshift(this.selectedDisplayItem);
        this.selectedDisplayItem = null;
      }


       // selectedGridField is next availible grid field
       let newSelectedItem = this.addedDisplayFields[index - 1];
       if(newSelectedItem < 0){
         newSelectedItem = 0;
       }
 
       if(newSelectedItem != null && typeof newSelectedItem != "undefined"){
         this.selectedDisplayItem = newSelectedItem;
       }else{
         // get first if at least one field is present
         if(this.addedDisplayFields.length > 0){          
           this.selectedDisplayItem = this.addedDisplayFields[0];
         }else{
           this.selectedDisplayItem = null;
         }                
       }  
    }
  }

  doubleClickSearchFieldAdd(){
    if(this.selectedSearchItem != null && typeof this.selectedSearchItem != "undefined"){
      this.addSearchField();
    }    
  }

  doubleClickDisplayFieldAdd(){
    if(this.selectedDisplayItem != null && typeof this.selectedDisplayItem != "undefined"){
      this.addDisplayField();
    }    
  }

  doubleClickSearchFieldRemove(){
    if(this.selectedSearchItem != null && typeof this.selectedSearchItem != "undefined"){
      this.removeAddedSearchField();
    }    
  }

  doubleClickDisplayRemove(){
    if(this.selectedDisplayItem != null && typeof this.selectedDisplayItem != "undefined"){
      this.removeAddedDisplayField();
    }    
  }

  translate(key: string) {
    return this.translationsService.translate(key);
  }

  addSortField(){
    this.selectedSortFields.push({Name: "", Translation: "", order: "asc"});
  }

  loadLeftMenuNodeOptions(){    
    this.leftMenuNodes = [];
    let leftMenuNodesStorage = this.localStorageService.get("/api/navigation/getNodes_left-menu");

    if(leftMenuNodesStorage){
      let leftMenuNodesArray = JSON.parse(leftMenuNodesStorage);
      if(leftMenuNodesArray && leftMenuNodesArray.length > 0){
        this.leftMenuNodes = this.findNodesWithEmptyUrl(leftMenuNodesArray);
      }
    }    
  }

  findNodesWithEmptyUrl(nodes: any[]): { Title: string; Id: number }[] {
    let result: { Title: string; Id: number }[] = [];
  
    function getFullTitle(node: any): string {
      const titles: string[] = [];
      let current = node;
      while (current) {
        titles.unshift(current.Title);
        if (current.ParentID && current.ParentID > 0) {
          current = nodes.find(x => x.Id === current.ParentID);
        } else {
          current = null;
        }
      }
      return titles.join(" - ");
    }
  
    function traverse(node: any, level: number = 0) {
      const isUrlEmpty = node.Url === "" || node.Url === null || node.Url === undefined;
      const isLevel2 = level === 1; // since level starts at 0 for root, level 1 means immediate child of root
  
      if (isUrlEmpty || isLevel2) {
        result.push({ Title: getFullTitle(node), Id: node.Id });
      }
  
      if (node.Children && node.Children.length > 0) {
        node.Children.forEach(child => traverse(child, level + 1));
      }
    }
  
    nodes.forEach(rootNode => traverse(rootNode));
    return result;
  }
  
  
  removeSortField(index: number) {
    // Remove the sort field at the specified index
    this.selectedSortFields.splice(index, 1);
  }

  onSortFieldChange(index: number, event: any) {
    // Extract the selected value from the event
    const selectedFieldName = event.value;

    // Find the corresponding field from availibleSortFields
    const selectedField = this.availibleSortFields.find(field => field.Name === selectedFieldName);

    if (this.selectedSortFields[index] && selectedField) {
      // Update the sortField Name at the specified index
      this.selectedSortFields[index].Name = selectedFieldName;      
    }
  }

  sortOrderChange(index: number, event: any) {
    // Extract the selected value from the event
    const selectedOrder = event.value;

    // Update the sortField order at the specified index
    if (this.selectedSortFields[index]) {
      this.selectedSortFields[index].order = selectedOrder;
    }
  }

  onLeftMenuNodeChange(event: MatSelectChange) {    
    this.leftMenuNode = this.leftMenuNodes?.find(x => x.Id === event.value?.Id) || null;    
  }

  async saveUpdateViewSettings(){
    DynamicLoadingUtil.loader.showLoader = true;
    
    let searchFieldsMapped: any[] = [];
    if(this.addedSearchFields){
      let orderCtn = 1;
      this.addedSearchFields.forEach(element => {        
        searchFieldsMapped.push({ "PropertyPath": element.Name, "Order": orderCtn });
        orderCtn++;
      });
    }

    let displayFieldsMapped: any[] = [];
    if(this.addedDisplayFields){
      let orderCtn = 1;
      this.addedDisplayFields.forEach(element => {
        displayFieldsMapped.push({ "PropertyPath": element.Name, "Order": orderCtn });
        orderCtn++;
      });
    }
        
    let filterQuery: string | null = null;
      
    if(this.queryBuilderModel && this.queryBConfig && this.queryBuilderModel.rules && this.queryBuilderModel.rules.length > 0){
      try{
        let parsedQueryBuilder = this.searchService.parseQueryBuilder(this.queryBuilderModel, this.queryBConfig, null);      
        if(parsedQueryBuilder){
          filterQuery = JSON.stringify(parsedQueryBuilder);
        }

      }catch{}      
    }      

    let viewSorterJson: string|null = null;
    let errorSort = false;
    if(this.selectedSortFields && this.selectedSortFields.length > 0){      
      for(let k = 0; k < this.selectedSortFields.length; k++){
        if(this.selectedSortFields[k].Name == null || typeof this.selectedSortFields[k].Name == "undefined" || this.selectedSortFields[k].Name.length == 0){          
          this.showCustomErrorMessage("Izberite polje za sortiranje ali odstranite dodano polje");              
          errorSort = true;
        }
      }
    }

    
    if(errorSort == false){
      // need to parse to WG search sorting structure
      let parsedSortingFields = this.searchService.parseViewSettingsSortingForBackend(this.selectedSortFields, this.modelName);
      if(parsedSortingFields && parsedSortingFields.length > 0){
        // FOR NOW WE SUPPORT ONLY 1 SORT FIELD, NEED TO REFACTOR BACKEND FIRST 
        let sortFieldObject = parsedSortingFields[0];
        if(sortFieldObject){
          viewSorterJson = JSON.stringify(sortFieldObject);
        }
      }                    

      let requestModel = {
      "CurrentSearchSettingId": this.currentSettingId,
      "SearchViewName": this.viewLabel,
      "SearchPlaceholderTitle": this.placeHolderTitle,
      "FilterQuery": filterQuery,
      "DisplayFields": displayFieldsMapped,
      "SearchFields": searchFieldsMapped,
      "IsGlobalView": this.globalView,
      "DefaultSorter": viewSorterJson,
      "AddOnLeftMenuRoot": this.addOnLeftMenuRoot,
      "FormUrl": this.params["url"],
      "LeftMenuOrder":this.leftMenuNodeOrder
      };
      


      if(this.leftMenuNode){
        requestModel["LeftMenuNavigationNodeParentId"] = this.leftMenuNode["Id"];
      }

      if(this.createNewView === true){           

        this.userService.saveNewSearchView(requestModel).subscribe({
          next: async data => {

            if(data){

              if(data.error === true){
                this.showCustomErrorMessage("Napaka: " + data.message);              
              }else{
                // we get UserSearchSetting.View.Id back, we only need this to redirect to new view
                let currentUrl = this.router.url;
                // data represent id of UserSearchSetting.View (this is what we need to redirect to new view, everything else in url is the same)
                if(data.viewid && data.viewid > 0){
                  if(requestModel.AddOnLeftMenuRoot === true || requestModel["LeftMenuNavigationNodeParentId"] > 0 || this.currentLeftNavNodeId > 0){
                    // need to reload left menu items in local storage
                    await this.routeNavigationService.reloadApplicationLeftMenu();                    
                  }

                  // redirect to new view
                  // replace view url param with new viewid            
                  const newViewUrl = this.utilityService.updateURLQueryParam(currentUrl, 'view', data.viewid.toString());
                  this.utilityService.processNavigationUrl(newViewUrl, null, true, true);
                  this.dialogRef.close();
                }
              }
            }else{
              this.showCustomErrorMessage("Napaka");
            }          

            DynamicLoadingUtil.loader.showLoader = false;         
          },
          error: error => { 
            this.showCustomErrorMessage("Napaka");       
            DynamicLoadingUtil.loader.showLoader = false;
          }
        });      
      }else{      

        this.userService.updateSearchView(requestModel, this.onlyGridSettings).subscribe({
          next: async response => {

            if(response){

              if(response.error === true){
                this.showCustomErrorMessage("Napaka: " + response.message);              
              }else{
                // we get UserSearchSetting.View.Id back, we only need this to redirect to new view
                let currentUrl = this.router.url;
                // data represent id of UserSearchSetting.View (this is what we need to redirect to new view, everything else in url is the same)
                if(response.data){
                  
                  if(requestModel.AddOnLeftMenuRoot === true || requestModel["LeftMenuNavigationNodeParentId"] > 0 || this.currentLeftNavNodeId > 0){
                    // need to reload left menu items in local storage
                    await this.routeNavigationService.reloadApplicationLeftMenu();                    
                  }

                  // we should delete only for current search view not all
                  for (let [key, value] of Object.entries(localStorage)) {
                    if (key.endsWith("usersearch") || key.endsWith("usergrid")) {
                      this.localStorageService.remove(key);
                    }
                  }

                  // redirect to new view
                  // replace view url param with new viewid            
                  const newViewUrl = this.utilityService.updateURLQueryParam(currentUrl, 'view', response.data.View.Id.toString());
                  this.utilityService.processNavigationUrl(newViewUrl, null, true, true);
                  this.dialogRef.close();
                }
              }
            }else{
              this.showCustomErrorMessage("Napaka");
            }          

            DynamicLoadingUtil.loader.showLoader = false;         
          },
          error: error => { 
            this.showCustomErrorMessage("Napaka");       
            DynamicLoadingUtil.loader.showLoader = false;
          }
        });

      }    
    }else{
      DynamicLoadingUtil.loader.showLoader = false;
    }
  }

  dropSearchField(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.addedSearchFields, event.previousIndex, event.currentIndex);
  }

  dropDisplayField(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.addedDisplayFields, event.previousIndex, event.currentIndex);
  }

  private showCustomErrorMessage(message: string) {
    this.validationErrorMessage = message;
    setTimeout(() => {
      this.validationErrorMessage = "";
    }, 10000); // 5000 milliseconds = 5 seconds
  }
}


